<template>
  <div class="ma-4 px-4">
    <searchBar :addField="false" @updateSearch="(v) => (search = v)" />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="StudentElectiveHeaders"
            :search="search"
            :items="items"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import searchBar from "@/components/searchBar.vue";
import { StudentElectiveHeaders } from "@/constants/headers";

export default {
  components: { searchBar },
  data() {
    return {
      items: [],
      search: "",
      StudentElectiveHeaders,
      programBatches: [],
      partners: [],
      courses: [],
      program_batch_id: null,
      partner_id: null,
      course_id: null,
    };
  },
  created() {
    this.program_batch_id = this.$route.query?.program_batch_id;
    this.partner_id = this.$route.query?.partner_id;
    this.course_id = this.$route.query?.course_id;
    this.initialise();
  },
  methods: {
    async initialise() {
      await Promise.all([
        this.getProgramBatches(),
        this.getPartners(),
        this.getCourses(),
      ]);

      const programBatch = this.getProgramBatchName(this.program_batch_id);
      const program = this.getPartnerName(this.partner_id);
      const course = this.getCourseName(this.course_id);

      if (!program || !programBatch || !course) {
        this.$store.commit("showSnackbar", {
          message: "Program or Program Batch Missing",
          color: "error",
        });
        this.$router.go(-1);
        return;
      }
      this.$store.commit("setBreadcrumbs", [
        { text: "Elective", to: { name: "Elective" } },
        {
          text: `${programBatch} - ${program}`,
          to: {
            path: "/student_elective_course",
            query: {
              program_batch_id: this.program_batch_id,
              partner_id: this.partner_id,
            },
          },
        },
        { text: `${course}` },
      ]);
      this.getListOfStudentElectives();
    },
    async getProgramBatches() {
      await this.$axios.get("/program_batches").then((res) => {
        this.programBatches = res.data.data;
      });
    },
    async getPartners() {
      await this.$axios.get("/partners").then((res) => {
        this.partners = res.data.data;
      });
    },
    async getCourses() {
      await this.$axios.get("/courses").then((res) => {
        this.courses = res.data.data;
      });
    },
    getProgramBatchName(id) {
      if (!id) return "";
      const programBatch = this.programBatches.find((p) => p.id == id);
      return programBatch ? programBatch.name : "";
    },
    getPartnerName(id) {
      if (!id) return "";
      const partner = this.partners.find((p) => p.id == id);
      return partner ? partner.name : "";
    },
    getCourseName(id) {
      if (!id) return "";
      const course = this.courses.find((p) => p.id == id);
      return course ? course.name : "";
    },
    async getListOfStudentElectives() {
      await this.$axios
        .get("/list_student_electives_by_group", {
          params: {
            program_batch_id: this.program_batch_id,
            partner_id: this.partner_id,
            course_id: this.course_id,
          },
        })
        .then((res) => {
          this.items = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    customFilter(value, search, item) {
      if (!search) return true;

      const programName = this.getPartnerName(item.partner_id);
      const programBatchName = this.getProgramBatchName(item.program_batch_id);

      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        programName.toLowerCase().includes(search.toLowerCase()) ||
        programBatchName.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
